import React from "react";
import PropTypes from "prop-types";
import { Badge } from "@mui/material";

const SFBadge = (props) => {
  return <Badge badgeContent={props.badgeContent} anchorOrigin={props.anchorOrigin} {...props}>{props.children}</Badge>;
};

SFBadge.defaultProps = {
  overlap: "rectangular",
  variant: "standard",
  badgeContent: 0,
  invisible: false,
  max: 100,
  anchorOrigin: {
    vertical: "top",
    horizontal: "right",
  },
  color: "primary"
};

SFBadge.propTypes = {
  variant: PropTypes.oneOf(["dot", "standard"]),
  children: PropTypes.node,
  badgeContent: PropTypes.number,
  color: PropTypes.string,
  invisible: PropTypes.bool,
  max: PropTypes.number,
  overlap: PropTypes.oneOf(["circular", "rectangular"]),
  anchorOrigin: PropTypes.object,
};

export default SFBadge;
